import * as types from '@/store/mutation-types';
import _ from 'lodash';

const mutations = {
  [types.ADD_DRAFT](state, payload) {
    payload.site.drafts.push(payload.draft);
  },
  [types.UPDATE_PAGE_TEMPLATE_BLOCK](state, p) {
    if (p.newBlock) {
      // insert new block
      let newIndex = _.findIndex(p.blocks, { _id: p.lastBlock });
      // if template block is not yet in the page (typically this is in
      // the event a user adds more blocks to a template that is already
      // in use by other pages), we need to insert the block at the index
      // in the template + 1 as it should take precedence over the page
      if (newIndex === -1) {
        newIndex = 0;
      } else {
        newIndex = newIndex + 1; // eslint-disable-line
      }
      p.blocks.splice(newIndex, 0, p.block);
    } else {
      // replace old block
      p.blocks.splice(p.blockIndex, 1, p.block);
    }
  },
  [types.REMOVE_PAGE_TEMPLATE_BLOCK](state, p) {
    p.blocks.splice(p.blockIndex, 1);
  },
};

const actions = {
  addDraft: ({ commit, rootState }, draft) => {
    const p = {
      site: rootState.Websites.currentSite,
      draft,
    };
    commit(types.ADD_DRAFT, p);
  },
  updateTemplatedPages({ commit, rootState }, p) {
    this._vm.$log.debug('updateTemplatedPages: ', p);
    // this will only update state for all pages and drafts using the
    // template being saved with the new changes. this action will return
    // an array of the pages changed.
    const site = rootState.Websites.currentSite;
    const drafts = site.pages.concat(site.drafts);
    const dynamics = [];
    if (site.dynamic) {
      _.forOwn(site.dynamic, (type) => {
        if (type.pages) {
          _.forEach(type.pages, (page) => {
            dynamics.push(page);
          });
        }
      });
    }
    const pages = drafts.concat(dynamics);
    const updates = [];
    _.forEach(pages, (page) => {
      if (page.templateID && page.templateID === p.template._id) {
        updates.push(new Promise((resolve) => {
          let lastBlock = false;
          _.forEach(p.template.blocks, (block, i) => {
            // go and find the block in the page using this template
            const blockIndex = _.findIndex(page.blocks, { _id: block._id });
            const newBlock = blockIndex === -1;
            // we update the new template blocks per page
            commit(types.UPDATE_PAGE_TEMPLATE_BLOCK, {
              blocks: page.blocks,
              blockIndex,
              block,
              newBlock,
              lastBlock,
            });
            lastBlock = block._id;
            // resolve the promise when we finish the last block
            if (i === p.template.blocks.length - 1) {
              resolve(page);
            }
          });
          // we need to also check if blocks were removed from the template
          _.forEach(page.blocks, (block, i) => {
            const blockIndex = _.findIndex(p.template.blocks, { _id: block._id });
            if (block.templateRegion && blockIndex === -1) {
              // remove from page
              commit(types.REMOVE_PAGE_TEMPLATE_BLOCK, {
                blocks: page.blocks,
                blockIndex: i,
              });
              // resolve the promise when we finish the last block
              if (i === page.blocks.length - 1) {
                resolve(page);
              }
            } else {
              resolve();
            }
          });
        }));
      }
    });
    return Promise.all(updates);
  },
};

export default {
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/global-view/editor/page/top-control-bar/creator-options/vuex.js